module.exports = __webpack_public_path__ + "files/300373ada70571cef7d998aa13c84dff.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Lora-regular.eot
 ** module id = 395
 ** module chunks = 0
 **/